module.exports = __webpack_public_path__ + "img/snowshowers.dec108a9.png";